import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import * as rk from "../../localization/resourceKeys";
import i18n from "../../i18n";
import { withTranslation } from "react-i18next";
import "./stateSelector.css";
import { SkipNavLink } from "@reach/skip-nav";
import { Logger } from "../../Logger/logger";
import { setRequestForm } from "../../redux/requestForm/requestFormAction";
import "@reach/skip-nav/styles.css";
import BottomLine from "../Footer/BottomLine";
import USFAQS from "../../media/2025-10-13 - VW - US_FAQS (Revised per Oregon).pdf";
import RedirectModal from "../RedirectModal/RedirectModal";
import PropTypes from "prop-types";

const StateSelector = (props) => {
  const history = useHistory();
  const [isSecureKeyModalOpen, setIsSecureKeyModalOpen] = useState(false);

  const handleNewRequest = () => {
    const payload = {
      ...props.requestForm,
      selectedFlow: "new",
    };
    props.setRequestForm(payload);
    history.push({ pathname: "/requestqualifier", props: props });
    Logger.info(
      `User Clicked on "Submit a Privacy Rights Request" button`,
      `Location ==> ${window.location.pathname}`,
      `User Clicked on "Submit a Privacy Rights Request" button`
    );
  };

  const handleCheckRequest = () => {
    const payload = {
      ...props.requestForm,
      selectedFlow: "check",
    };
    props.setRequestForm(payload);
    Logger.info(
      `Initiated checking the status of the request`,
      `Location ==> ${window.location.pathname}`,
      `User Clicked on "Check the Status of my Request" button`
    );
    if (props?.country?.toLowerCase() === "canada") {
      return setIsSecureKeyModalOpen(true);
    } else return history.push("/requestqualifier");
  };

  const isUS = props?.country?.toLowerCase() === "us";
  const hyperLink = isUS && (
    <a
      className="a-link-cta"
      href={USFAQS}
      target="_blank"
      rel="noopener noreferrer"
    >
      {i18n.t(rk.STATE_SELECTION_NOTE1_HYPERLINK)}
    </a>
  );

  return (
    <>
      <SkipNavLink />

      <div>
        <div className="welcome-note">
          <span>
            {i18n.t(rk.STATE_SELECTION_NOTE1)} {hyperLink}{" "}
            {i18n.t(rk.STATE_SELECTION_NOTE2)}
          </span>
        </div>
      </div>

      <div className="u-mt">
        <div id="status-buttons-div">
          <div className="button-wrapper">
            <div className="sg-component-variant">
              {!isUS && (
                <button
                  data-test-id="submit-request-btn"
                  id="state-selector-submit-request-btn"
                  data-testid="submit-request-btn"
                  className="c-btn  c-btn--secondary submit-status-button-text"
                  onClick={() => handleNewRequest()}
                >
                  <span className="c-btn__text">
                    {i18n.t(rk.STATE_SUBMIT_BUTTON)}
                  </span>
                </button>
              )}
            </div>
            <div>
              <button
                data-test-id="request-status-btn"
                data-testid="request-status-btn"
                className="c-btn  c-btn--secondary check-status-button-text"
                onClick={() => handleCheckRequest()}
              >
                <span className="c-btn__text">
                  {i18n.t(rk.STATE_CHECK_STATUS)}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="request-footer-wrapper">
        <div id="request-footer-content" className="request-footer-content-2">
          <div id="request-footer-text">
            {i18n.t(rk.VERFICIATION_FORM.NOTE2)}
          </div>
          <BottomLine />
        </div>
      </div>
      <RedirectModal
        isModalOpen={isSecureKeyModalOpen}
        setIsModalOpen={setIsSecureKeyModalOpen}
        isCheckMyStatus
        id="check-my-status"
      />
    </>
  );
};

StateSelector.propTypes = {
  requestForm: PropTypes.object.isRequired,
  setRequestForm: PropTypes.func.isRequired,
  country: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    requestForm: state.requestForm,
    country: state.initialReducer.country,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setRequestForm: (payload) => dispatch(setRequestForm(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(StateSelector));
